import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EllipsisFinderDirective } from './ellipsis-finder.directive';
import { NumberOnlyDirective } from './numbers-only.directive';
import { InputTrimDirective } from './input-trim.directive';
import { InputValidationGeneralDirective } from './input-validation-general.directive';
import { ClickOutside } from './outside-click.directive';
import { OnCreate } from './element-init-checker.directive';
import { EscapeCountryCode } from './escape-countrycode-delete.directive';
import { DateFormatDirective } from './date-format.directive';
import { PreventEmoteDirective } from './prevent-emote.directive'
import { InputTwoDecimalDirective } from './input-two-decimal.directive';
import { PostcodeRangeCheckDirective } from './postcode-range-check.directive';


@NgModule({
    imports: [],
    declarations: [
        EllipsisFinderDirective,
        NumberOnlyDirective,
        InputTrimDirective,
        OnCreate,
        ClickOutside,
        EscapeCountryCode,
        DateFormatDirective,
        PreventEmoteDirective,
        InputValidationGeneralDirective,
        InputTwoDecimalDirective,
        PostcodeRangeCheckDirective,
    ],
    providers: [],
    exports: [
        EllipsisFinderDirective,
        NumberOnlyDirective,
        InputTrimDirective,
        OnCreate,
        ClickOutside,
        EscapeCountryCode,
        DateFormatDirective,
        PreventEmoteDirective,
        InputValidationGeneralDirective,
        InputTwoDecimalDirective,
        PostcodeRangeCheckDirective,
    ]
})

export class DirectivesModule { }